<template>
  <myhead :value="value" @next="next" v-model:next="nextColor" @lookmore="more">{{
    $route.query.title || $route.meta.title
  }}</myhead>

  <div ref="wrapper" id="containerScroll">
    <div class="flex between detailsearch">
      <div style="width:66.1333vw">
        <Search @click="this.$router.push({path:'/shop/search',query:{type:'detail'}})"></Search>
      </div>
      <img src="@/assets/img/icon30-3.png" @click="this.$router.push({path:'/shop/cart'})">
      <img src="@/assets/img/icon67.png" @click="handleShowShare">
    </div>
    <div class="shopdetail">
      <van-sticky :offset-top="44" @scroll="handleScroll">
        <div class="shopdetail-bar" :style="{opacity: stickyOpticty,visibility: isExit?'visible':'hidden'}">
          <ul class="flex between size14 a345">
            <li v-for="item in list" :key="item.id" :class="{ active: active === item.id }" @click="handleSwitch(item.id,item.node)">
              {{ item.name }}
            </li>
          </ul>
        </div>
      </van-sticky>
      <!-- 产品 -->
      <div class="block" id="cp">
        <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
          <van-swipe-item v-for="item in goodsInfo.images" :key="item">
            <img :src="item" style="width:100%;height:100vw" :onerror="Imgerror">
          </van-swipe-item>
        </van-swipe>
        <div class="infoContainer">
          <p class="size14 infoContainer-tle flex between">
            <span class="weight">{{ goodsInfo.goods_name }}</span>
            <span class="size12" v-if="goodsInfo.sales_method == 3"  @click="showAuction = true">查看出价资格</span>
            <span class="size12 C777" v-else>销量{{ goodsInfo.sales_sum }}</span>
          </p>
          <div class="flex between mt10 size12" v-if="goodsInfo.sales_method == 3">
            <p  class="flex">
              距结束:
              <van-count-down :format="goodsInfo.auction.auction_time>60*60*24*7?'DD 天':'HH : mm : ss'" :time="goodsInfo.auction.auction_time * 1000" class="C999" />

            </p>
            </div>
          <div class="flex between mt10 size12" v-if="goodsInfo.sales_method == 3">
            <p class="product_item" >起拍价: <span class="size14 Cred">￥{{ goodsInfo.auction.starting_price }}</span> </p>
            <p class="product_item" v-if="goodsInfo.auction.auction_type != 3">当前: <img style="width:4.5vw;" v-if="goodsInfo.auction.auction_type == 2 && goodsInfo.auction.is_finish == 0" src="@/assets/img/hidden1.png" alt="">  <span v-else class="size14 Cred">￥{{ goodsInfo.auction.new_price }}</span> </p>
            <p class="product_item" v-else></p>
          </div>
          <div class="infoContainer-price flex between">
            <p></p>
            <p class="size14" v-if="goodsInfo.sales_method == 1">¥<span class="size16 b500">{{ goodsInfo.shop_price }}</span></p>
            <p v-if="goodsInfo.sales_method == 2" class="size14" @click="handleZX">报价咨询</p>

          </div>
          <BidSheet v-if="goodsInfo.sales_method == 3" v-model:bid_status="bid_status" v-model:goods_id="goodsInfo.goods_id" ></BidSheet>
          <div class="infoContainer-detail">
            <p class="infoContainer-detail-tle size12">
              <span>商品详情</span>
            </p>
              <img :src="item" class="img_box" style="display:block;margin:0 auto;max-width: 100%" :onerror="Imgerror" v-for="item in goodsInfo.goods_content" :key="item">
          </div>
        </div>
      </div>
      <!-- 成本 -->
      <div id="cb" style="top:-76px;visibility:hidden;position:relative"></div>
      <div class="block">
        <div class="basecontainer">
          <div class="scroll_title a345 size14 weight">成本</div>
          <img :src="item" class="img_box" style="display:block;margin:0 auto;max-width: 100%" v-for="item in goodsInfo.cost_img" :key="item" />
        </div>
      </div>
      <!-- 评论 -->
      <div id="pl" style="top:-76px;visibility:hidden;position:relative"></div>
      <div class="block">
        <div class="basecontainer">
          <p class="a345 size14 weight">评论</p>
          <div class="score flex center between">
            <div class="score-block" :class="{'c3F7C93':(typeid === 1)}" @click="handleComment(1)">
              <p class="score-title">质量</p>
              <p class="score-content">{{ goodsInfo.quality_score }}
                <span>分</span>
              </p>
              <p class="score-bottom">{{ goodsInfo.quality_score_name }}</p>
            </div>
            <div class="score-block" :class="{'c3F7C93':(typeid === 2)}" @click="handleComment(2)">
              <p class="score-title">物流</p>
              <p class="score-content">{{ goodsInfo.logistics_score }}
                <span>分</span>
              </p>
              <p class="score-bottom">{{ goodsInfo.logistics_score_name }}</p>
            </div>
            <div class="score-block" :class="{'c3F7C93':(typeid === 3)}" @click="handleComment(3)">
              <p class="score-title">服务</p>
              <p class="score-content">{{ goodsInfo.service_score }}
                <span>分</span>

              </p>
              <p class="score-bottom">{{ goodsInfo.service_score_name }}</p>
            </div>
          </div>
          <div class="score-list">
            <div class="score-list-tle flex between">
              <p class="size14 a345">
                {{typeid === 1? '质量':typeid === 2?'物流':'服务'}}评论({{typeid === 1? (goodsInfo.quality_score_count) : (typeid === 2 ? (goodsInfo.logistics_score_count) : (goodsInfo.service_score_count))}}+)
              </p>
              <router-link
                :to="{path:'/shop/comment',query:{typeid:typeid,goods_id: this.$route.query.goods_id,title:typeid === 1? '质量评价':typeid === 2?'物流评价':'服务评价'}}">
                <img src="@/assets/img/icon35.png" class="width20px">
              </router-link>
            </div>
            <div class="score-list-con">
              <!-- <div class="score-list-info">
                <div class="flex between center">
                  <div class="flex center">
                    <img src="" class="score-list-info__img" :onerror="Imgerror">
                    <p class="score-list-info__name">李某某</p>
                  </div>
                  <p class="score-list-info__time">2023-02-03</p>
                </div>
                <p class="score-list-info__desc size14">物美价廉 真好呀！</p>
              </div> -->
              <template v-for="item in commentList.data" :key="item.id">
                <div class="score-list-info" v-if="item.content !== ''"
                  @click="this.$router.push({path:'/shop/comment/detail',query:{id:item.id,typeid:typeid}})">
                  <div class="flex between center">
                    <div class="flex center">
                      <img :src="item.head_pic" class="score-list-info__img">
                      <p class="score-list-info__name">{{ item.nickname }}</p>
                    </div>
                    <p class="score-list-info__time">{{ item.add_time }}</p>
                  </div>
                  <div class="score-list-info__desc">
                    <p class="score-list-info__hint">{{ item.score }} <span>分</span> </p>
                    {{ item.content }}
                  </div>
                  <div class="score-list-info-descimg flex">
                    <img :src="img" :onerror="Imgerror" v-for="(img,index) in item.images" :key="index">
                  </div>
                  <div class="reply" v-if="item.reply_content != ''">
                    <p class="size14">卖家回复：{{ item.reply_content }}</p>
                    <p class="size12">{{ item.reply_time }}</p>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>

      <!-- 运营 -->
      <div id="yy" style="top:-76px;visibility:hidden;position:relative"></div>
      <div class="block">
        <div class="basecontainer">
          <p class="a345 size14 weight">运营</p>
          <img :src="item" class="img_box" :onerror="Imgerror" v-for="(item,index) in goodsInfo.operate_img" :key="index" style="display:block;margin: 0 auto" />
        </div>
      </div>

      <!-- 事故 -->
      <div id="sg" style="top:-76px;visibility:hidden;position:relative"></div>
      <div class="block">
        <div class="basecontainer" style="padding-bottom:calc(14vw + 74px)">
          <p class="a345 size14 weight">事故</p>
          <div class="center mary10 size16" v-if="accidentlist.length == 0">—暂无事故—</div>
          <van-list v-else v-model:loading="loading" :finished="finished" finished-text="" @load="onLoad">
            <template v-for="(item,index) in accidentlist" :key="index">
              <div style="margin-top: 5.3333vw;">
                <div class="accident-list size14">
                  <div>
                    <div class="flex accident-list-tle-box">
                      <p class="accident-list-tle">{{ item.no }} {{ item.name }}</p>
                      <router-link :to="{
                          path: '/shop/accident/schedule',
                          query: { order_id: item.order_id,type:'order' },
                        }">查看进程
                      </router-link>
                    </div>
                    <p class="accident-list-t">{{item.judgment_nickname}}裁决结果: <span v-if="!item.outcome"
                        style="font-size:16px;font-weight:bold;color:red">未结案，请等待裁决结果</span> </p>
                    <p v-html="item.outcome" class="ellipsis3"></p>
                  </div>
                  <div class="accident-b flex between center">
                    <p>{{ item.add_time }}</p>
                    <div class="accident-behavior flex center">
                      <div
                        @click="this.$router.push({path:'/shop/comment/accidentdetail',query:{title:'事故详情',goods_id: this.$route.query.goods_id,id:item.id}})"
                        class="flex center">
                        <img src="@/assets/img/shop7.png">
                        <p>({{item.comment_count}}+)</p>
                      </div>
                      <div class="flex center" @click="accidentnotlike(item)">
                        <img src="@/assets/img/shop10.png">
                        <p>({{item.bad_count}}+)</p>
                      </div>
                      <div class="flex center" @click="accidentLike(item)">
                        <img src="@/assets/img/shop5.png">
                        <p>({{item.good_count}}+)</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </van-list>
        </div>
      </div>
    </div>
  </div>

  <DeatilTabbar v-if=" goodsInfo.sales_method == 1 || goodsInfo.sales_method == 2" v-model:sales_method="goodsInfo.sales_method" v-model:is_buy="goodsInfo.is_buy" v-model:msg="goodsInfo.msg" v-model:goods_id="goodsInfo.goods_id"
    v-model:isCollect="goodsInfo.is_collect" @handleZf="handleZf" @handleJg="handleJg" @handleCollect="handleCollect" :is_concept="is_concept">
  </DeatilTabbar>
  <AuctionTabbar v-if="goodsInfo.sales_method == 3"  v-model:is_buy="goodsInfo.is_buy" v-model:msg="goodsInfo.msg" v-model:goods_id="goodsInfo.goods_id"
    v-model:isCollect="goodsInfo.is_collect"  @handleCollect="handleCollect" @afterSubmit="afterSubmit" :is_concept="is_concept"
    :max_price="goodsInfo.auction.auction_type == 1?goodsInfo.auction.new_price:goodsInfo.auction.starting_price"></AuctionTabbar>
    
  <van-share-sheet v-model:show="showShare" title="立即分享给好友" :options="options" @select="onSelect" />
  <van-popup v-model:show="showBottom" position="bottom">
    <div class="popup">
      <Steeper :goodsInfo="goodsInfo" :handleSj="handleSj" @closeJs="closeJs"></Steeper>
    </div>
  </van-popup>
  <!-- 查看出价资格 -->
  <van-popup v-model:show="showAuction" style="padding:20px;width:80%">
   <div class="flex between">
    <p></p>
    <div class="size18 bold">出价资格</div>
    <van-icon @click="showAuction = false" name="cross" size="22" />
   </div>
    <div v-if="goodsInfo.auction.screening_buyers">所有人</div>
    <div v-else>
      <p class="mb5" v-if="goodsInfo.auction.user_level">人权等级:{{ goodsInfo.auction.user_level }}</p>
      <p class="mb5" v-if="goodsInfo.auction.administration_min != 0 && goodsInfo.auction.administration_max != 100">行政排名:{{ goodsInfo.auction.administration_min }}% - {{ goodsInfo.auction.administration_max }}%</p>
      <p class="mb5" v-if="goodsInfo.auction.labor_union_min != 0 && goodsInfo.auction.labor_union_max != 100">工会排名:{{ goodsInfo.auction.labor_union_min }}% - {{ goodsInfo.auction.labor_union_max }}%</p>
      <p class="mb5" v-if="goodsInfo.auction.association_min != 0 && goodsInfo.auction.association_max != 100">协会排名:{{ goodsInfo.auction.association_min }}% - {{ goodsInfo.auction.association_max }}%</p>
      <p class="mb5" v-if="goodsInfo.auction.commune_min != 0 && goodsInfo.auction.commune_max != 100">公社排名:{{ goodsInfo.auction.commune_min }}% - {{ goodsInfo.auction.commune_max }}%</p>
      <p class="mb5" v-if="goodsInfo.auction.company_min != 0 && goodsInfo.auction.company_max != 100">公司排名:{{ goodsInfo.auction.company_min }}% - {{ goodsInfo.auction.company_max }}%</p>
      <p class="mb5" v-if="goodsInfo.auction.family_min != 0 && goodsInfo.auction.family_max != 100">家族排名:{{ goodsInfo.auction.family_min }}% - {{ goodsInfo.auction.family_max }}%</p>
      <p class="mb5" v-if="goodsInfo.auction.congress_min != 0 && goodsInfo.auction.congress_max != 100">国会排名:{{ goodsInfo.auction.congress_min }}% - {{ goodsInfo.auction.congress_max }}%</p>
      <p class="mb5" v-if="goodsInfo.auction.rank_min != 0 && goodsInfo.auction.rank_max != 100">综合排名:{{ goodsInfo.auction.rank_min }}% - {{ goodsInfo.auction.rank_max }}%</p>
    </div>
  </van-popup>
</template>
<script>
import {showConfirmDialog} from 'vant'
import useClipboard from 'vue-clipboard3'
// import scrollIntoView from 'smooth-scroll-into-view-if-needed'
import DeatilTabbar from "./tabbar.vue";
import AuctionTabbar from "./auctiontabbar.vue";
import BidSheet from "./bidsgeet.vue";

import Search from "@/components/Search.vue";
import Steeper from "./jiesuan.vue";
// import PopupTabbar from "../order/tabbar.vue";
import ajax from "@/utils/request.js";
export default {
  name: 'Shopdetail',
  components: { DeatilTabbar, Search, Steeper,AuctionTabbar,BidSheet },
  data () {
    return {
      active: 0,
      list: [
        {
          id: 0,
          name: "产品",
          node: "cp"
        },
        {
          id: 1,
          name: "成本",
          node: 'cb'
        },
        {
          id: 2,
          name: "评论",
          node: 'pl'
        },
        {
          id: 3,
          name: "运营",
          node: 'yy'
        },
        {
          id: 4,
          name: "事故",
          node: 'sg'
        },
      ],
      showShare: false,
      options: [
        [
          { name: "微博", icon: "weibo" },
          { name: "QQ", icon: "qq" },
          { name: "复制链接", icon: "link" },
        ],
      ],
      showAuction:false,
      goodsInfo: {},
      showBottom: false,
      handleSj: "",
      commentList: [],
      typeid: 1,
      is_concept: 0,
      accidentlist: [],
      loading: false,
      finished: false,
      page: 1,
      docScrollTop: {
        cp: null,
        cb: null,
        pl: null,
        yy: null,
        sg: null
      },
      oldScrollTop: 0,
      scrollTimer: null,
      isExit: true,
      listid: this.$route.query.goods_id,
      nextColor: false,
      stickyOpticty: 1,
      timer: null,
      goodsId: null,
      bid_status:0,// 更新竞价版状态
      // sum: 0,
      // total: 0,
      // currentStepper: -1,//当前触发的步进器
      // specJson: [],//上传的规格json
    };
  },
  methods: {
    afterSubmit(){
      // 提交出价后更新数据
      ajax.post("products/getinfo", { goods_id: this.$route.query.goods_id }).then(res=>{
        this.goodsInfo.auction = res.data.auction
      })
      this.bid_status += 1

    },
    // dsq add 咨询
    handleZX(){
      if (!localStorage.getItem('loginInfo')) {
        showConfirmDialog({
          title: '是否登录'
        })
          .then(() => {
            // on confirm
            this.$router.push({ path: "/login" })
          }).catch(() => {
            return false
          });

      } else {
        this.$router.push({ path: '/shop/feedback', query: { title: '咨询定制商品', goods_id: this.goodsInfo.goods_id, type: 2 } })
      }
    },
    closeJs () {
      this.showBottom = false
    },
    handleSwitch (id, node) {
      // 使用方法
      document.getElementById(node).scrollIntoView();
      this.active = id;
      
      // scrollIntoView(document.getElementById(node),{
      //   ease: (t) => t,
      // })
    },
    handleShowShare () {
      this.showShare = !this.showShare
    },
    onSelect (option) {
      if (option.icon === "link") {
        const { toClipboard } = useClipboard()

        try {
          toClipboard(window.location.href)
          this.showToast("复制链接成功")
        } catch (e) {
          this.showToast("当前浏览器版本不支持复制，请长按复制")
        }
        // navigator.clipboard.writeText(window.location.href);
        // this.showToast("复制成功")
      }
      if (option.icon === "qq") {
        if (navigator.share) {
          navigator.share({
            title: document.title,
            text: '分享',
            url: window.location.href
          })
        } else {
          window.location.href = "https://connect.qq.com/widget/shareqq/index.html?url=" + window.location.href
        }

      }
      if (option.icon === "weibo") {
        if (navigator.share) {
          navigator.share({
            title: document.title,
            text: '分享',
            url: window.location.href
          })
        } else {
          window.location.href = "http://service.weibo.com/share/share.php?url=" + window.location.href
        }
      }
    },
    handleZf (val) {
      if (this.goodsInfo.is_own == 1) {
        this.showToast("不能购买自己的商品")
      } else {
        this.showBottom = val
        this.handleSj = "zf"
      }

    },
    handleJg (val) {
      this.showBottom = val
      this.handleSj = "jg"

    },
    handleCollect (val) {
      this.goodsInfo.is_collect = val
    },
    getComment (typeid) {
      const data = {
        typeid: typeid,
        goods_id: this.$route.query.goods_id,
        page: 1
      }
      let result = null
      let comment = []
      ajax.post("products/getevaluatelist", data).then(res => {
        result = res
        result.data.forEach(item => {
          if (item.content !== "" && comment.length < 5) {
            comment.push(item)
          }
        })
        result.data = comment
        this.commentList = result
        // this.commentList = res
      })
    },
    handleComment (val) {
      this.typeid = val;
      this.getComment(this.typeid)
    },
    //获取事故列表
    getAccidentList (listid) {
      this.loading = true
      const data = {
        page: this.page,
        id: listid
      }
      return ajax.post("products/getaccidentlist", data).then(res => {
        if (res.data.length < 10) {
          this.accidentlist = this.accidentlist.concat(res.data)
          this.finished = true
        } else {
          this.accidentlist = this.accidentlist.concat(res.data)
          this.page++
        }
      }).catch(() => {
        this.finished = true
      })
    },
    //事故点赞
    accidentLike (item) {
      const data = {
        typeid: 1,
        id: item.id
      }
      ajax.post("products/accidenthandle", data).then(res => {
        if (res.errcode === 1) {
          this.showToast("点赞成功")
          item.good_count++
          item.bad_count = item.bad_count == 0 ? '0' : --item.bad_count
        }
      })
    },
    //事故取消点赞
    accidentnotlike (item) {
      const data = {
        typeid: 2,
        id: item.id
      }
      ajax.post("products/accidenthandle", data).then(res => {
        if (res.errcode === 1) {
          this.showToast("点踩成功")
          item.bad_count++
          item.good_count = item.good_count == 0 ? '0' : --item.good_count
        }
      })
    },
    //下拉获取事故列表
    onLoad () {
      this.getAccidentList(this.listid).finally(() => {
        this.loading = false
      })
    },
    //滚动处理
    handleScroll () {
      let top = document.getElementById('containerScroll');
      this.docScrollTop = {
        cp: (document.getElementById('cp').offsetTop),
        cb: (document.getElementById('cb').offsetTop),
        pl: (document.getElementById('pl').offsetTop),
        yy: (document.getElementById('yy').offsetTop),
        sg: (document.getElementById('sg').offsetTop)
      }
      // 添加scrollTitleHeight为标题框的高度,确保标题快到时导航便跳转
      // 获取具有类名 "scroll_title" 的元素
      const scrollTitle = document.querySelector('.scroll_title');

      // 获取元素的高度
      const scrollTitleHeight = scrollTitle.offsetHeight;
      top = top.scrollTop + scrollTitleHeight
      if (top <= this.docScrollTop.cb) {
        this.active = 0
      } else if (top > this.docScrollTop.cb && top <= this.docScrollTop.pl) {
        this.active = 1
      } else if (top > this.docScrollTop.pl && top <= this.docScrollTop.yy) {
        this.active = 2
      } else if (top > this.docScrollTop.yy && top <= this.docScrollTop.sg) {
        this.active = 3
      } else {
        this.active = 4
      }
    },
    next () {
      history.forward()
    },
  },
  mounted () {
    ajax.post("products/getinfo", { goods_id: this.$route.query.goods_id }).then(res => {
      this.goodsInfo = { ...res.data }
      this.is_concept = this.goodsInfo.is_concept
      this.goodsInfo.spec.forEach(item => {
        item.sum = 0
      })
    });
    const that = this
    document.getElementById('containerScroll').addEventListener('scroll', function () {

      const scrollTop = document.getElementById('containerScroll').scrollTop
      if (that.scrollTimer) {
        clearTimeout(that.scrollTimer)
      }
      if ((scrollTop - that.oldScrollTop) > 0) {
        that.scrollTimer = setTimeout(() => {

          if (document.getElementById('containerScroll').scrollTop - that.oldScrollTop == 0) {
            that.isExit = false
          }
          clearTimeout(that.scrollTimer)
        }, 500)
        that.isExit = true
      } else {
        that.isExit = true
      }
      that.oldScrollTop = scrollTop
    })


  },
  activated () {
    if (history.state.forward) {
      this.nextColor = true
    }
    this.getComment(1)
    const search = location.search.slice(1, location.length).split("=")
    search.forEach((item, index) => {
      if (item == 'goods_id') {
        this.listid = search[index + 1]
      }
    })
    this.page = 1,
      this.accidentlist = []
    this.finished = false
    this.getAccidentList(this.listid).finally(() => {
      this.loading = false
    })
    ajax.post("products/getinfo", { goods_id: this.$route.query.goods_id }).then(res => {
      this.goodsInfo = { ...res.data }
      this.is_concept = this.goodsInfo.is_concept
      this.goodsInfo.spec.forEach(item => {
        item.sum = 0
      })
    });

    const topData = sessionStorage.getItem('shopdetail')
    if (topData) {
      const data = JSON.parse(topData)
      if (this.$route.query.goods_id == data.id) {
        setTimeout(() => {
          document.getElementById('containerScroll').scrollTop = Number(data.top)
        }, 500)
      } else {
        setTimeout(() => {
          document.getElementById('containerScroll').scrollTop = 0
        }, 500)
      }
    }

    //储存当前页面goods_id,退出页面时缓存到sessionStorage中
    this.goodsId = this.$route.query.goods_id
    
  },
  deactivated () {
    this.showBottom = false
    const data = {
      id: this.goodsId,
      top: this.oldScrollTop
    }
    sessionStorage.setItem('shopdetail', JSON.stringify(data))
  }
};
</script>
<script setup></script>
<style scoped lang="scss">
.scroll {
  overflow: unset;
}
.block {
  background-color: #fff;
}
.detailsearch {
  padding: 0 4vw;
  margin-bottom: 1.6vw;
  img {
    width:5.3333vw;
    &:last-child {
      width: 4.2667vw;
    }
  }
}
.basecontainer {
  padding: 5.3333vw 4vw;
}
.my-swipe .van-swipe-item {
  color: #fff;
  font-size: 20px;
  line-height: 150px;
  text-align: center;
  background-color: #fff;
}
.shopdetail-bar {
  // position: sticky;
  height: 8.5333vw;
  padding: 0 6.1333vw;
  background-color: rgba(255, 255, 255, 0.75);
  // top: 44px;
  z-index: 7;
  cursor: pointer;
  ul {
    width: 100%;
    height: 100%;
    li {
      font-size: 14px;
      color: #666666;
    }
  }
}
.shopdetail-bar ul li.active {
  color: #3f7c93;
}
.infoContainer {
  padding: 3.2vw 4vw 0;
  .infoContainer-tle {
    color: #333333;
    letter-spacing: 1px;
  }
  .product_item{
    width: 50%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .infoContainer-price {
    margin-top: 3.2vw;
    p {
      &:first-child {
        color: #666666;
      }
      &:last-child {
        color: #ff0000;
      }
    }
  }
  .infoContainer-detail img {
      display: block;
      max-width: 100%;
      margin: 10px auto;
    }
  .infoContainer-detail-tle {
    text-align: center;
    color: #999999;
    margin-top: 7.4667vw;
    span {
      position: relative;
      &:before {
        content: "";
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        width: 9.0667vw;
        height: 1px;
        left: -11.2vw;
        background-color: #999999;
      }
      &:after {
        content: "";
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        width: 9.0667vw;
        height: 1px;
        right: -11.2vw;
        background-color: #999999;
      }
    }
  }
}
#cb img {
  display: block;
  max-width: 100%;
  margin: 0 auto;
}
#yy img {
  display: block;
  max-width: 100%;
  margin: 0 auto;
}
// 评分
.score {
  margin-top: 2.6667vw;
  .score-block {
    width: 28.8vw;
    padding-bottom: 10px;
    border-radius: 10px;
    font-family: 'a345';
    font-weight: bold;
    background-color: #f0f0f0;
    .score-title{
      padding:10px 0 ;
      background-color: #6191a5;
      border-radius: 10px;
      color: #fff;
      font-size: 18px;
    }
    .score-content{
      font-size: 30px;
      color: #6191a5;
      span{
        font-size: 12px;
      }
    }
    .score-bottom{
      font-size: 12px;
      color:#92b3c1;
    }
    p {
      &:nth-child(2) {
        line-height: 1;
        margin-top: 2.6667vw;
        margin-bottom: 2.6667vw;
      }
    }
  }
  .c3F7C93 {
    background-color: rgba(63, 124, 147, 0.2);
  }
}
.score-list {
  .score-list-tle {
    margin-top: 5.3333vw;
  }
  .score-list-con {
    padding: 2px 3.2vw;
    background: #F6F6F6;
    margin-top: 2.6667vw;
    border-radius: 2.1333vw;
    .score-list-info {
      padding: 2.6667vw 0;
      .score-list-info__img {
        width: 6.4vw;
        height: 6.4vw;
        border-radius: 50%;
        margin-right: 1.0667vw;
        background-color: skyblue;
      }
      .score-list-info__name {
        font-family: 'a345';
        font-size: 14px;
        color: #333333;
      }
      .score-list-info__time {
        font-size: 12px;
        color: #999999;
      }
    }
    .score-list-info__desc {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      color: #666666;
      margin-top: 3.2vw;
      font-size: 14px;
      color: #999;
      .score-list-info__hint{
        margin-right: 5px;
        padding: 0 5px;
        background-color: #6191a5;
        color: #fff;
        font-size: 14px;
        border-radius: 10px;
        span{font-size: 10px;}
      }
    }
    .score-list-info-descimg {
      margin-top: 2.6667vw;
      img {
        object-fit: cover;
        width: 21.3333vw;
        height: 21.3333vw;
        margin-right: 2.6667vw;
        &:nth-child(4) {
          margin-right: 0;
        }
      }
    }
  }
}
// 事故
.accident-list {
  background: #F6F6F6;
  padding: 1.6vw;
  border-radius: 2.1333vw;
  p {
    color: #666666;
  }
  .accident-list-tle-box {
    justify-content: space-between;
  }
  .accident-list-tle-box a {
    color: #3f7c93;
    font-size: 14px;
  }
  .accident-list-tle {
    color: #999999;
    word-break: break-all;
  }
  .accident-list-t {
    margin-top: 2.6667vw;
    margin-bottom: 1.0667vw;
  }
  .accident-b {
    margin-top: 5.3333vw;
    p {
      color: #999999;
    }
    .accident-behavior {
      img {
        display: block;
        width: 5.3333vw;
        margin-left: 2.6667vw;
        margin-right: 1.0667vw;
      }
    }
  }
}
.c3F7C93 {
  background-color: rgba(63, 124, 147, 0.2);
}
//弹窗
.popup {
  padding: 6.4vw 4vw 17.0667vw;
  .popup-up-r {
    padding-left: 2.6667vw;
  }
  .popup-shopimg {
    width: 26.6667vw;
    height: 26.6667vw;
    object-fit: contain;
  }
  .popup-shopimg-small {
    display: block;
    width: 4.8vw;
    height: 4.8vw;
    object-fit: contain;
    border-radius: 50%;
    margin-right: 1.0667vw;
  }
  .popup-tle {
    width: 53.3333vw;
    overflow:hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow:ellipsis;
  }
  .regular-box {
    padding-top: 5.3333vw;
  }
  .regular {
    margin-bottom: 3.2vw;
  }
  .regular-before {
    p {
      &:first-child {
        width: 26.1333vw;
        height: 8vw;
        line-height: 8vw;
        text-align: center;
        color: #999999;
        font-size: 14px;
        background: #F6F6F6;
        border-radius: .5333vw;
      }
      &:last-child {
        color: #999999;
        font-size: 12px;
        margin-left: 2.6667vw;
      }
    }
  }
  .regular-after {
    p {
      &:first-child {
        padding: 1.3333vw .8vw;
        text-align: center;
        border: 1px solid rgba(204, 204, 204, .2);
      }
      &:last-child {
        margin-left: 5.3333vw;
      }
    }
  }
}
.reply {
  border-radius: 5px;
  background-color: #ddd;
  padding: 5px;
  p {
    word-break: break-all;
    &:first-child {
      margin-bottom: 5px;
    }
    &:last-child {
      color: #999;
    }
  }
}
.img_box{
  width: 100%;

}
</style>